import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 15C7 15 5 13 5 10.5S7 6 9.5 6 14 8 14 10.5 12 15 9.5 15zm0-8C7.6 7 6 8.6 6 10.5S7.6 14 9.5 14s3.5-1.6 3.5-3.5S11.4 7 9.5 7zm8 11h-16C.7 18 0 17.3 0 16.5v-10C0 5.7.7 5 1.5 5H3c.4 0 1.1-.3 1.4-.6l.6-.6c.4-.4 1.3-.8 2-.8h5c.7 0 1.6.4 2.1.9l.6.6c.2.2.9.5 1.3.5h1.5c.8 0 1.5.7 1.5 1.5v10c0 .8-.7 1.5-1.5 1.5zM1.5 6c-.3 0-.5.2-.5.5v10c0 .3.2.5.5.5h16c.3 0 .5-.2.5-.5v-10c0-.3-.2-.5-.5-.5H16c-.7 0-1.6-.4-2.1-.9l-.6-.6c-.2-.2-.9-.5-1.3-.5H7c-.4 0-1.1.3-1.4.6l-.5.5c-.5.5-1.4.9-2.1.9H1.5z',
  ],
  height: 20,
  width: 20,
});
